const SLIDE_KEYS = ['start', 'low', 'medium', 'high', 'critical'];

export const SLIDE_KEYS_EXPORT = SLIDE_KEYS;

export const parseSeverityParameters = (value) => {
    if (!value || typeof value === 'object') return value || {};
    try {
        const parsed = JSON.parse(value.trim());
        return typeof parsed === 'string' ? JSON.parse(parsed) : parsed || {};
    } catch {
        try {
            const unwrapped = value.trim().replace(/^["']|["']$/g, '');
            return JSON.parse(unwrapped.replace(/\\"/g, '"')) || {};
        } catch {
            return {};
        }
    }
};

export const getDefaultBooleanSeverity = (event, params) => {
    if (params?.defaultSeverity != null) return Number(params.defaultSeverity);
    if (event?.defaultSeverity != null) return Number(event.defaultSeverity);
    if (event?.defaultSeverityValue != null) return Number(event.defaultSeverityValue);
    const type = String(event?.eventType || '');
    const name = String(event?.eventName || '');
    if (type === 'Critical') return 75;
    if (type === 'DMS' && /distracted|smoking/i.test(name)) return 25;
    return 50;
};

export const slidesEqual = (a, b) => a && b && SLIDE_KEYS.every(k => Number(a[k]) === Number(b[k]));

export const extractSlidesFromPoints = (points) => {
    const byLabel = points.reduce((acc, p) => {
        const label = String(p?.label || '').toLowerCase();
        if (label) acc[label] = p?.x;
        return acc;
    }, {});
    return {
        start: Number(byLabel.start ?? 0),
        low: Number(byLabel.low ?? 0),
        medium: Number(byLabel.medium ?? 0),
        high: Number(byLabel.high ?? 0),
        critical: Number(byLabel.critical ?? byLabel.top ?? 0),
    };
};

export const mphToKmh = (mph) => Math.round(mph * 1.60934);
export const kmhToMph = (kmh) => Math.round(kmh / 1.60934);

export const convertSlides = (slides, converter) => ({
    start: converter(slides.start),
    low: converter(slides.low),
    medium: converter(slides.medium),
    high: converter(slides.high),
    critical: converter(slides.critical),
});
